
/* injects from baggage-loader */

'use strict';

export default class JobDetailsController {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/jobs/components/job.details.controller.js